import Vue from 'vue'

const radio = new Vue()

export default radio
